import React, {useMemo} from 'react';
import {DataGridPro, DataGridProProps} from '@mui/x-data-grid-pro';
import AurDataGridNoRowsOverlay from '../aur-data-grid-no-rows-overlay/AurDataGridNoRowsOverlay';
import AurDataGridLoadingOverlay from '../aur-data-grid-loading-overlay/AurDataGridLoadingOverlay';
import AurDataGridErrorOverlay from '../aur-data-grid-error-overlay/AurDataGridErrorOverlay';

type Props = DataGridProProps & {
  className?: string;
  noRowsOverlay?: React.JSXElementConstructor<unknown>;
  noRowOverlayHeight?: number;
  noRowOverlayClass?: string;
  isReqLoading?: boolean;
  haveReqError?: boolean;
  onErrorRefresh?: () => void;
};

const AurTreeDataGridPro: React.FC<Props> = (props) => {
  const {
    className,
    noRowsOverlay,
    noRowOverlayHeight,
    noRowOverlayClass,
    isReqLoading,
    haveReqError,
    onErrorRefresh,
    ...rest
  } = props;

  const noDataGridOverlay = useMemo(() => {
    if (isReqLoading) return AurDataGridLoadingOverlay;
    if (haveReqError) return AurDataGridErrorOverlay;
    if (noRowsOverlay) return noRowsOverlay;
    return AurDataGridNoRowsOverlay;
  }, [isReqLoading, haveReqError]) as React.JSXElementConstructor<unknown>;

  return (
    <DataGridPro
      treeData
      className={`aur-tree-data-grid-pro ${className}`}
      headerFilters
      columnHeaderHeight={48} // Default value, can be override from parent
      headerFilterHeight={50} // Default value, can be override from parent
      rowHeight={36} // Default value, can be override from parent
      disableColumnMenu
      slots={{
        noRowsOverlay: noDataGridOverlay,
        noResultsOverlay: noRowsOverlay ?? AurDataGridNoRowsOverlay,
      }}
      slotProps={{
        noRowsOverlay: {
          containerHeight: noRowOverlayHeight,
          containerClass: noRowOverlayClass,
          onRefresh: onErrorRefresh,
          enableParentWrapper: false,
        } as unknown as Record<string, unknown>,
        noResultsOverlay: {
          containerHeight: noRowOverlayHeight,
          containerClass: noRowOverlayClass,
        } as unknown as Record<string, unknown>,
      }}
      {...rest}
    />
  );
};

export default AurTreeDataGridPro;
